import React from 'react';
import { useNavigate } from 'react-router';

import { BackButton, NOTIFICATION_TYPE, Notification } from 'components';
import { ExporterForm } from 'features/sellers/components/form/ExporterForm';

export default function AddExporter() {
  const navigate = useNavigate();

  const onSuccess = () => {
    Notification(NOTIFICATION_TYPE.SUCCESS, 'Exporter was created successfully');
    navigate(-1);
  };

  const onError = (error) => {
    Notification(NOTIFICATION_TYPE.DANGER, error.message);
  };

  return (
    <div>
      <div className="mb-4">
        <BackButton />
      </div>

      <div className="row mb-4">
        <h1>Add Seller (Exporter)</h1>
      </div>

      <ExporterForm action="create" onSuccess={onSuccess} onError={onError} />
    </div>
  );
}
